import * as React from "react";
import NewButton from "../uiMerge/newButton";

import { NewModal } from "../uiMerge/newModal";
import ErrorIcon from "../../assets/svg/failedNewIcon.svg";

// import * as ROUTES from "../../constants/routes";

interface VerificationFailedModalProps {
    visible: boolean;
    onCancel: () => void;
    onOk?: () => void;
}

export const CloseAccountModal: React.FC<VerificationFailedModalProps> = (props) => {
    const { visible, onCancel, onOk } = props;

    return (
        <NewModal isOpen={visible} colorClass="bg-[#1E1E1E]" heightClass="h-[395px]"  roundedClass="rounded-2xl" widthClass="w-[329px]" showCloseButton={false} animationClass="grow-in" position="center" onClose={onCancel} onOk={onOk}>
            <div className="py-5 text-white flex flex-col mt-5 justify-center items-center">
                <div className="text-center w-[250px]  gap-y-2 flex flex-col justify-center items-center">
                    <div className="pb-4">     <img src={ErrorIcon} alt="success" /></div>

                    <div className="flex flex-col items-center space-y-2">
                        <p className="text-2xl font-bold">
                            Close Account?
                        </p>

                        <p className="text-md text-[#CECECF] w-[213px] font-normal">
                            You will no longer have access to Njoy benefits. This cannot be undone.
                        </p>
                    </div>



                </div>
                <div className="w-full pt-5 px-[1rem] gap-2 flex flex-col">
                    <NewButton
                        variant="primary"
                        fullWidth
                        onClick={onOk}>
                        Close Account
                    </NewButton>

                    <NewButton
                        variant="outline"
                        fullWidth
                        onClick={onCancel}>
                        Go Back
                    </NewButton>
                </div>
            </div>
        </NewModal>
    );
}
